import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageCropperComponent } from './components/image-cropper/image-cropper.component';
import { ImageCropperComponent as NgxImageCropperComponent } from 'ngx-image-cropper';
import { RacesTimeComponent } from './components/races-time/races-time.component';
import { ModalComponent } from './components/modal/modal.component';
import { ClickOutsideDirective } from 'src/app/shared/directives/click-out-side.directive';
import { CommonModalComponent } from './common-modal/common-modal.component';
import { DragDropFileToUploadDirective } from './directives/drag-drop-file-upload.directive';
import { CommonMediaUploadComponent } from './components/common-media-upload/common-media-upload.component';
import { SafePipe } from './pipes/safe.pipe';
import { CustomDropdownComponent } from './components/dropdown/custom-dropdown.component';
import { ButtonComponent } from './component/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { GenericTooltipComponent } from './components/generic-tooltip/generic-tooltip.component';


@NgModule({
  imports: [
    CommonModule,
    SafePipe,
    RacesTimeComponent,
    ImageCropperComponent,
    ModalComponent,
    CommonModalComponent,
    CommonMediaUploadComponent,
    CustomDropdownComponent,
    NgxImageCropperComponent,
    DragDropFileToUploadDirective,
    ClickOutsideDirective,
    TranslateModule, 
    ButtonComponent,
    GenericTooltipComponent,
  ],
  exports: [
    ImageCropperComponent,
    DragDropFileToUploadDirective,
    RacesTimeComponent,
    ModalComponent,
    CommonModalComponent,
    ClickOutsideDirective,
    CommonMediaUploadComponent,
    CustomDropdownComponent,
    SafePipe,
    ButtonComponent,
    TranslateModule,
    GenericTooltipComponent,
  ],
  
})
export class SharedModule { }